import React, { ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { cards } from 'sections/DigitalTools/data';
import Card from 'components/Card';
import styles from 'sections/DigitalTools/components/SectionCards/SectionCards.module.scss';

const cn = classNames.bind(styles);

const SectionCards = (): ReactElement => {
  const cardItems = cards.map((card) => {
    return (
      <Card className={cn('card')} key={card.icon}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/DigitalTools/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>  
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
        {card.link
          ?
          <Card.Footer className={cn('card__buttons')}>
            <Link className={cn('card__button-learn')} href={card.link as Route}>
              Learn more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </Card.Footer>
          :
          null
        }
      </Card>
    );
  });
  
  return (
    <section className={cn('cards')}>
      <div className={cn('container')}>
        <ul className={cn('cards__list')}>
          {cardItems}
        </ul>
      </div>  
    </section>
  );
};

export default SectionCards;